// extracted by mini-css-extract-plugin
export default {"FontFamilyAxiformaSemiBold":"AxiformaSemiBold,Helvetica,sans-serif","calendarSpan":"Ge9a3f3","calendarIcon":"G6558db"};